import React from "react";

const EquipmentDetailModal = ({ item, onClose }) => {
  if (!item) return null;

  const fields = [
    { label: "Name of Equipment",                   value: item?.name_of_equipment },
    { label: "Date of Purchase",                    value: item?.date_of_purchase ? new Date(item.date_of_purchase).toLocaleDateString() : null },
    { label: "Cost of Equipment",                   value: item?.cost_of_equipment ? `Rs. ${item.cost_of_equipment}` : null },
    { label: "Name & Address of Supplier",          value: item?.nameAndAddressOfSupplier },
    { label: "Date of Manufacture",                 value: item?.date_of_manufacture ? new Date(item.date_of_manufacture).toLocaleDateString() : null },
    { label: "Date of Installation",                value: item?.date_of_installation ? new Date(item.date_of_installation).toLocaleDateString() : null },
    { label: "Department Where Installed",          value: item?.department_where_intalled },
    { label: "Environmental Control",               value: item?.environmental_control },
    { label: "Spare Parts Inventory",               value: item?.spare_parts_inventory },
    { label: "Technical Manual / Circuit Diagrams", value: item?.technical_manualCircuit_diagramLiterature },
    { label: "After Sale Service Arrangement",      value: item?.after_sale_service_arrangement },
    { label: "Warranty Period",                     value: item?.warranty_period },
    { label: "Life of Equipment",                   value: item?.life_of_equipment },
    { label: "Depreciation Per Year",               value: item?.depreciation_per_year ? `Rs. ${item.depreciation_per_year}` : null },
    { label: "Cost of Maintenance",                 value: item?.cost_of_maintenance ? `Rs. ${item.cost_of_maintenance}` : null },
    { label: "Date of Condemnation",                value: item?.date_of_condemnation ? new Date(item.date_of_condemnation).toLocaleDateString() : null },
    { label: "Date of Replacement",                 value: item?.date_of_replacement ? new Date(item.date_of_replacement).toLocaleDateString() : null },
    { label: "Other Relevant Remarks",              value: item?.other_relevant_remarks },
  ];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden mt-28"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-[#2F6DB4] px-6 py-4 flex items-center justify-between ">
          <div>
            <h2 className="text-white text-[15px] font-[600]">Equipment Details</h2>
            <p className="text-gray-400 text-[11px] mt-0.5">Full record information</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors text-xl leading-none"
          >
            &times;
          </button>
        </div>

        <div className="p-6 space-y-3 max-h-[70vh] overflow-y-auto">
          {fields.map(({ label, value }) => (
            <div
              key={label}
              className="flex gap-3 border-b border-gray-100 pb-3 last:border-0 last:pb-0"
            >
              <span className="text-[12px] text-gray-400 w-[50%] shrink-0 pt-0.5">{label}</span>
              <span className="text-[13px] font-[500] text-gray-800 break-words">
                {value || <span className="text-gray-300 font-normal">—</span>}
              </span>
            </div>
          ))}
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
          <button
            onClick={onClose}
            className="bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-5 py-2 rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EquipmentDetailModal;